
import Component from "./index.vue"
export default {
    id: "bulk-upload", // (required) uuid
    icon: require("./icon.svg"), // (required) url to tool icon
    title: "Bulk Upload", // (required) Title shown on content tools view
    description: "Bulk Upload Content from your computer to PLANT", // (required) Operation description
    available: false, // (optional) set to true if tool is available to use in the platform
    Component // (required) VueComponent to show when operation is selected
}